"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _Instructions = _interopRequireDefault(require("./components/Instructions"));
var _Results = _interopRequireDefault(require("./components/Results"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, "catch": function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Boilerplate = window.cccisd && window.cccisd.boilerplate;
var BulkUploaders = window.cccisd && window.cccisd.appDefs && window.cccisd.appDefs.bulkUpload;

/** JS part of Bulk Upload */
var BulkUploader = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function BulkUploader(props, context) {
    var _this;
    _classCallCheck(this, BulkUploader);
    _this = _callSuper(this, BulkUploader, [props, context]);
    _defineProperty(_this, "getDefinition", function () {
      var stateDef = _this.state.definition;
      if (stateDef && Object.keys(stateDef).length) {
        return stateDef;
      }
      var propsDef = _this.props.definition;
      if (propsDef && Object.keys(propsDef).length) {
        return propsDef;
      }
      if (BulkUploaders && _typeof(BulkUploaders) === 'object' && BulkUploaders[_this.props.handle]) {
        return BulkUploaders[_this.props.handle];
      }
      return {};
    });
    _defineProperty(_this, "getColumns", function () {
      var def = _this.getDefinition();
      var allColumns = def.columns || [];
      var staticColumnsFrontEndDefaults = def.staticColumnsFrontEndDefaults || {};
      var staticColumnHandles = function () {
        var staticColumnsFromProps = _this.props.staticColumns ? Object.keys(_this.props.staticColumns) : [];
        var staticColumnsFromBuDef = staticColumnsFrontEndDefaults ? Object.keys(staticColumnsFrontEndDefaults) : [];
        return [].concat(_toConsumableArray(staticColumnsFromProps), _toConsumableArray(staticColumnsFromBuDef));
      }();
      return allColumns.filter(function (c) {
        return !staticColumnHandles.includes(c.name);
      });
    });
    _defineProperty(_this, "getTrigger", function () {
      if (_this.props.trigger) {
        return _this.props.trigger;
      }
      var definition = _this.getDefinition();
      return /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-secondary"
      }, definition.triggerText || 'Bulk Upload');
    });
    _defineProperty(_this, "getModalTitle", function () {
      if (_this.props.modalTitle) {
        return _this.props.modalTitle;
      }
      var definition = _this.getDefinition();
      if (definition.modalTitle) {
        return definition.modalTitle;
      }
      return 'Bulk Upload';
    });
    _defineProperty(_this, "getDescription", function () {
      if (_this.props.description) {
        return _this.props.description;
      }
      var definition = _this.getDefinition();
      if (definition.description) {
        return definition.description;
      }
      return 'Provide a CSV file below to begin the process.';
    });
    _defineProperty(_this, "beforeShow", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var def, definition;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            def = _this.getDefinition();
            if (!(def && Object.keys(def).length)) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            if (!_this.props.loadDefinition) {
              _context.next = 8;
              break;
            }
            _context.next = 6;
            return _this.props.loadDefinition();
          case 6:
            definition = _context.sent;
            _this.setState({
              definition: definition
            });
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    /**
     * Save the accepted file and mappings to the state, update view to
     * preflightProcessing, then trigger preflight check.
     * @param {File} acceptedFile The user-provided file
     * @param {Object} mapping Keys are bulk upload column names, values are
     *     0-indexed csv column
     */
    _defineProperty(_this, "acceptValidatedFile", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(acceptedFile, mapping) {
        var _this$props, deploymentId, handle, staticColumns, config, data, response, results;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this.setState({
                file: acceptedFile,
                mappedColumns: mapping
              });
              _this$props = _this.props, deploymentId = _this$props.deploymentId, handle = _this$props.handle;
              staticColumns = _this._getStaticColumnValues();
              config = {
                headers: {
                  'Content-Type': undefined
                }
              };
              data = new FormData();
              data.append('file', acceptedFile);
              data.append('handle', handle);
              data.append('mapping', JSON.stringify(mapping));
              if (deploymentId) {
                data.append('deploymentId', deploymentId);
              }
              if (staticColumns) {
                data.append('staticColumns', JSON.stringify(staticColumns));
              }
              // Submit file to back end for preflight analysis
              _context2.prev = 10;
              _context2.next = 13;
              return _cccisdAxios["default"].post(Boilerplate.route('api.nexus.bulkupload.preflight'), data, config);
            case 13:
              response = _context2.sent;
              if (response.data) {
                results = response.data;
                _this.setState({
                  currentView: 'preflightComplete',
                  results: results
                });
              }
              _context2.next = 20;
              break;
            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](10);
              console.error(_context2.t0);
            case 20:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[10, 17]]);
      }));
      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    /**
     * Clear the file, mapping, and results and re-display the
     * instructions.
     */
    _defineProperty(_this, "clearValidatedFile", function () {
      _this.setState({
        currentView: 'instructions',
        file: undefined,
        mappedColumns: {},
        results: {}
      });
    });
    /**
     * Send the successfully preflighted file for execution.
     */
    _defineProperty(_this, "runExecute", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var _this$props2, deploymentId, handle, loadData, _this$state, file, isSubmitting, mappedColumns, staticColumns, config, data, response, results;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _this$props2 = _this.props, deploymentId = _this$props2.deploymentId, handle = _this$props2.handle, loadData = _this$props2.loadData;
            _this$state = _this.state, file = _this$state.file, isSubmitting = _this$state.isSubmitting, mappedColumns = _this$state.mappedColumns;
            staticColumns = _this._getStaticColumnValues();
            if (!isSubmitting) {
              _context3.next = 5;
              break;
            }
            return _context3.abrupt("return");
          case 5:
            _this.setState({
              isSubmitting: true
            });
            config = {
              headers: {
                'Content-Type': undefined
              }
            };
            data = new FormData();
            data.append('file', file);
            data.append('handle', handle);
            data.append('mapping', JSON.stringify(mappedColumns));
            if (deploymentId) {
              data.append('deploymentId', deploymentId);
            }
            if (staticColumns) {
              data.append('staticColumns', JSON.stringify(staticColumns));
            }
            // Submit file to back end for preflight analysis
            _context3.prev = 13;
            _context3.next = 16;
            return _cccisdAxios["default"].post(Boilerplate.route('api.nexus.bulkupload.execute'), data, config);
          case 16:
            response = _context3.sent;
            if (response.data) {
              results = response.data;
              _this.setState({
                currentView: 'executeComplete',
                isSubmitting: false,
                results: results
              });
              if (loadData) {
                loadData();
              }
            }
            _context3.next = 24;
            break;
          case 20:
            _context3.prev = 20;
            _context3.t0 = _context3["catch"](13);
            console.error(_context3.t0);
            _this.setState({
              isSubmitting: true
            });
          case 24:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[13, 20]]);
    })));
    /**
     * Decide which component to display.
     * @return {Object} The component to render
     */
    _defineProperty(_this, "_getCurrentViewContent", function () {
      var _this$state2 = _this.state,
        currentView = _this$state2.currentView,
        results = _this$state2.results;
      var definition = _this.getDefinition();
      var columns = _this.getColumns();
      switch (true) {
        case currentView === 'instructions':
          // `Instructions` has uploader, column descriptions/matching,
          // example csv, and preflight validation button
          return /*#__PURE__*/_react["default"].createElement(_Instructions["default"], {
            acceptValidatedFile: _this.acceptValidatedFile,
            bulkType: definition.bulkType,
            clearValidatedFile: _this.clearValidatedFile,
            columns: columns,
            description: _this.getDescription()
          });
        case currentView === 'preflightComplete':
          // render preflight complete summary
          return /*#__PURE__*/_react["default"].createElement(_Results["default"], {
            clearValidatedFile: _this.clearValidatedFile,
            isPreflight: true,
            results: (results === null || results === void 0 ? void 0 : results.result) || results,
            runExecute: _this.runExecute
          });
        case currentView === 'executeComplete':
          // render summary of completed, executed job
          return /*#__PURE__*/_react["default"].createElement(_Results["default"], {
            clearValidatedFile: _this.clearValidatedFile,
            results: (results === null || results === void 0 ? void 0 : results.result) || results
          });
        default:
          return 'The current view is unrecognized, please contact support!';
      }
    });
    /**
     * Collate the staticColumns provided with the staticColumns that have
     * defaults, giving provided staticColumns precedence.
     * @return {Object} key:value dictionary for each static column
     */
    _defineProperty(_this, "_getStaticColumnValues", function () {
      var isShowWarnings = _this.state.currentView === 'instructions';
      var definition = _this.getDefinition();
      var staticColumnsFrontEndDefaults = definition.staticColumnsFrontEndDefaults || {};
      var staticColumnValues = _this.props.staticColumns || {};
      Object.keys(staticColumnsFrontEndDefaults).forEach(function (columnName) {
        // If static value is defined in both props and definition, use props
        if (columnName in staticColumnValues) {
          return;
        }

        // If value is Object, it should have the key "path" referring to window.cccisd
        // Otherwise, it is primitive and can be used as listed
        var value = staticColumnsFrontEndDefaults[columnName];
        if (value instanceof Object) {
          var path = value.path;
          if (typeof path !== 'string' && isShowWarnings) {
            console.error("Warning: staticColumnsFrontEndDefaults for '".concat(columnName, "' ") + "should be a primitive value or an object containing the string key \"path\"");
          }
          value = (0, _get2["default"])(window.cccisd, path, null);
        }
        staticColumnValues[columnName] = value;
      });
      Object.keys(staticColumnValues).forEach(function (columnName) {
        if ((staticColumnValues[columnName] === null || staticColumnValues[columnName] === undefined) && isShowWarnings) {
          console.error("Warning: value for static column '".concat(columnName, "' is not defined. Check ") + "'staticColumns' prop or 'staticColumnsFrontEndDefaults' in the bulk upload definition");
        }
      });
      return staticColumnValues;
    });
    _this.state = {
      canPreflight: false,
      // eslint-disable-line
      currentView: 'instructions',
      file: undefined,
      isSubmitting: false,
      mappedColumns: {},
      results: {},
      definition: {}
    };
    return _this;
  }
  _inherits(BulkUploader, _React$Component);
  return _createClass(BulkUploader, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.state.currentView !== nextState.currentView || this.state.results !== nextState.results || this.state.definition !== nextState.definition || nextProps.handle !== this.props.handle || nextProps.definition !== this.props.definition || nextProps.loadDefinition !== this.props.loadDefinition || nextProps.deploymentId !== this.props.deploymentId || nextProps.staticColumns !== this.props.staticColumns || nextProps.trigger !== this.props.trigger || nextProps.modalTitle !== this.props.modalTitle || nextProps.description !== this.props.description;
    }

    /*
     * If the definition-related props change, clear any dynamically loaded definitions
     */
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.definition !== prevProps.definition || this.props.handle !== prevProps.handle || this.props.loadDefinition !== prevProps.loadDefinition) {
        // Being careful to call setState within a conditional to avoid infinite loop
        //
        this.setState({
          definition: {}
        }); /* eslint-disable-line */
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        size: "large",
        title: this.getModalTitle(),
        trigger: this.getTrigger(),
        beforeShow: this.beforeShow,
        beforeShowSpinner: false,
        afterClose: this.props.afterClose
      }, /*#__PURE__*/_react["default"].createElement("div", null, this._getCurrentViewContent()));
    }
  }]);
}(_react["default"].Component);
_defineProperty(BulkUploader, "propTypes", {
  handle: _propTypes["default"].string.isRequired,
  definition: _propTypes["default"].object,
  loadDefinition: _propTypes["default"].func,
  deploymentId: _propTypes["default"].number,
  staticColumns: _propTypes["default"].object,
  trigger: _propTypes["default"].object,
  loadData: _propTypes["default"].func,
  modalTitle: _propTypes["default"].string,
  description: _propTypes["default"].string,
  afterClose: _propTypes["default"].func
});